import React from 'react';

const Title = ({ list, title, sub, type }) => {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-3 mb-2">
        <h2 className="text-2xl font-bold text-white">{title}</h2>
        <span className="inline-flex items-center justify-center w-7 h-7 text-sm font-semibold rounded-full bg-gray-700 text-white">
          {list.length}
        </span>
      </div>
      {sub && <p className="text-gray-400 text-sm whitespace-pre-line">{sub}</p>}
    </div>
  );
};

export default Title;
